import axios from '../../../../utils/AxiosUtils';
import {
    GET_SURVEY_PARTNERS,
    GET_RESTAURANT_SURVEY_PARTNER_SETTINGS,
    LOADING,
    RESET_RESTAURANT_SURVEY_PARTNER_SETTINGS
} from "../../../types";
import MessageUtils from "../../../../utils/MessageUtils";
import i18n from "../../../../i18next";

export const getSurveyPartners = () => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/survey-partner`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: GET_SURVEY_PARTNERS, payload: response.data })
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const getRestaurantSurveyPartnerSettings = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/survey-partner-settings`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: GET_RESTAURANT_SURVEY_PARTNER_SETTINGS, payload: response.data })
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const saveRestaurantSurveyPartnerSettings = (restaurantId, data) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/survey-partner-settings`;

        axios().put(url, data)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const resetRestaurantSurveyPartnerSettings = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/survey-partner-settings/reset`;

        axios().put(url, {})
            .then(() => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: RESET_RESTAURANT_SURVEY_PARTNER_SETTINGS, payload: false });
            }
            ).catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const invalidSurveyPartnerFormMessage = () => dispatch => {
    MessageUtils.errorMessageResponse(dispatch, '', i18n.t('screens:surveyPartnerScreen.emptyFields'));
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/SurveyPartnerActions.js